import { Organisation } from '@/domain/organisation/entities/organisation.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Result = Organisation | null;

/**
 * 3 return cases :
 * - organination object with field
 * - null => organisation do not exist
 * - reject => error during action
 */
export const getOrganisation = createAppAsyncThunk(
  'project/getOrganisation',
  async (
    _,
    { extra: { organisationGateway, snackbarGateway } },
  ): Promise<Result> => {
    try {
      const organisation = await organisationGateway.getOrganisation();
      return organisation;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetOrganisation.Message.error'));
}
